import * as React from 'react';

export const QuestionMarkIcon: React.FunctionComponent<{
  color: string;
  ariaName?: string;
}> = ({ color, ariaName }) => {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>{ariaName}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12.0002C22 17.5231 17.5228 22.0002 12 22.0002C6.47715 22.0002 2 17.5231 2 12.0002C2 6.4774 6.47715 2.00024 12 2.00024C17.5228 2.00024 22 6.4774 22 12.0002ZM12 8.00024C10.8954 8.00024 10 8.89567 10 10.0002H8C8 7.79111 9.79086 6.00024 12 6.00024H12.5C14.433 6.00024 16 7.56725 16 9.50024V10.2002C16 11.7466 14.7464 13.0002 13.2 13.0002C13.0895 13.0002 13 13.0898 13 13.2002V14.0002H11V13.2002C11 11.9852 11.985 11.0002 13.2 11.0002C13.6418 11.0002 14 10.6421 14 10.2002V9.50024C14 8.67182 13.3284 8.00024 12.5 8.00024H12ZM13 16.0002V18.0002H11V16.0002H13Z"
        fill={color}
      />
    </svg>
  );
};
